const dialogRecursMixins = {
  data() {
    return {
      idList: [],
      upIdList: [],
      level: -1,
      newDepartPeopleList: []
    }
  },
  methods: {
    // 处理初始数据
    recursData(list) {
      ++this.level
      for(let i in list) {
        if(this.level == 0) {
          list[i].pid = 0
        } 
        this.newDepartPeopleList.push(list[i])
        if(list[i].chil && list[i].chil.length > 0) {
          list[i].chil.map(item => {
            item.pid = list[i].id
            return item
          })

          this.recursData(list[i].chil)
        }
      }
      return list
    },

    // 根据id查找值
    recursFindUser(id) {
      let data = {}
      let {newDepartPeopleList} = this
      for(let i in newDepartPeopleList) {
        if(newDepartPeopleList[i].id == id) {
          data = newDepartPeopleList[i]
        }
      }
      return data
    },

    // 查找上级id
    recursFind(id) {
      let pid = 0
      let {newDepartPeopleList} = this
      // console.log("粟慧慧43304, pid: m9, pid:d32")
      for(let i in newDepartPeopleList) {
        if(newDepartPeopleList[i].id == id) {
          pid = newDepartPeopleList[i].pid
        }
      }
      return pid
    },

    // 查找所有上级id
    recursFindAll(id) {
      if(id == 0) return false
      let data = this.recursFind(id)
      if(data != 0 && data != undefined) {
        this.upIdList.push(data)
        this.recursFindAll(data)
      }
      return this.upIdList
    },

    // 查找所有上级id 
    recursFindAllId(id) {
      this.upIdList = []
      return this.recursFindAll(id)
    },

    // 查找下级id
    recursFindNext(id, list) {
      let idList = []
      let chilList = []
      let {newDepartPeopleList} = this
      list = list ? list : newDepartPeopleList
      for(let i in list) {
        if(list[i].id == id) {
          if(list[i].chil && list[i].chil.length > 0) {
            chilList = list[i].chil
          }
        }
      }
      for(let i in chilList) {
        idList.push(chilList[i].id)
      }
      return idList
    },

    // 查找所有下级id
    recursFindNextAll(id) {
      let list = []
      let idList = this.recursFindNext(id)
      this.idList.push(...idList)
      if(idList.length > 0) {
        for(let i in idList) {
          this.recursFindNextAll(idList[i])
        }
      }
      return this.idList
    },

    // 查找所有下级id
    recursFindNextAllId(id) {
      this.idList = []
      return this.recursFindNextAll(id)
    },

    // 查找id是否选中
    recursIdIfChecked(id) {
      let checked = false
      let { newDepartPeopleList } = this
      for(let i in newDepartPeopleList) {
        if(newDepartPeopleList[i].id == id) {
          checked = newDepartPeopleList[i].checked
        }
      }
      return checked
    },

    // 当对人员进行勾选后，再点击取消时，商户列表也要跟着取消
    recursLastCheck(id) {
      let upId = this.recursFind(id)
      let downId = this.recursFindNext(upId)
      console.log("***", upId, downId)
      if(downId.length == 1) {
          this.recursStatus(upId, true)
      } 
      else {
        let index = 0
        for(let i in downId) {
            if(this.recursIdIfChecked(downId[i])) {
                index++
            }
        }
        console.log(index)
        if(index == 1) {
            this.recursStatus(upId, true)
            if(upId != 0) {
              this.recursLastCheck(upId)
            }
        }
      }
    },

    /**
     * 更改状态
     * @param {*} id 需要改变状态的id
     * @param {*} checked  需要改变的状态(改变前)
     * @param {*} change 是否需要切换复选框效果
     */
    recursStatus(id, checked, change) {
      if(!checked) { checked = false }
      for(let i in this.newDepartPeopleList) {
        if(id == this.newDepartPeopleList[i].id) {
          this.newDepartPeopleList[i].checked = !checked
        }
      }
      if(!change) {
        this.$refs.departTable.toggleRowSelection(this.newDepartPeopleList.find(d => d.id == id), !checked)
      }
    },

    // 渲染全部
    recursCheck(val) {
      let newList = []
      let { newDepartPeopleList } = this
      this.SectionList = []
      this.$refs.departTable.clearSelection()
      for(let i in newDepartPeopleList) {
        newDepartPeopleList[i].checked = val
        this.$refs.departTable.toggleRowSelection(newDepartPeopleList[i], val)
        if(!newDepartPeopleList[i].pid) {
          newList.push(newDepartPeopleList[i])
        }
      }
      if(val) {
        for(let i in newList) {
          this.adjustPeople(newList[i])
        }
      }
    },

    // 添加/删除成员
    deletePeople(id, data) {
      if(data.checked) { return this.SectionList.push(data) }

      let index = false
      for(let i in this.SectionList) {
        if(this.SectionList[i].id == id) {
          index = i
        }
      }
      if(index) {
        this.SectionList.splice(index, 1)
      }
    },
  }
}

export default dialogRecursMixins


// WEBPACK FOOTER //
// ./src/assets/js/dialogRecursMixins.js